<template>
  <el-dialog
    :title="dialogTitle"
    :visible="visible"
    width="700px"
    :before-close="handleClose"
    @close="handleDialogClose"
    class="modify-info-dialog"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    custom-class="custom-dialog"
  >
    <div class="modify-content" v-loading="loading" element-loading-text="加载中...">
      <el-form :model="formData" :rules="rules" ref="modifyForm" label-width="100px">
        <!-- 职业 -->
        <el-form-item label="职业" prop="occupationId">
          <el-select v-model="formData.occupationId" placeholder="请选择职业" class="form-select">
            <el-option v-for="item in occupationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <!-- 工作年限 -->
        <el-form-item label="工作年限" prop="workYears">
          <el-select v-model="formData.workYears" placeholder="请选择工作年限" class="form-select">
            <el-option
              v-for="item in workYearsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 所在城市 -->
        <el-form-item label="所在城市" prop="areaId">
          <el-cascader
            v-model="formData.areaId"
            :options="areaList"
            :props="cascaderProps"
            placeholder="请选择城市"
            class="form-select"
          ></el-cascader>
        </el-form-item>

        <!-- 名企经历 -->
        <el-form-item label="名企经历">
          <el-switch
            v-model="formData.hasFamousCompany"
            active-text="有"
            inactive-text="无"
            @change="handleFamousCompanyChange"
          ></el-switch>
        </el-form-item>

        <!-- 知名公司 -->
        <el-form-item v-if="formData.hasFamousCompany" label="知名公司">
          <el-select
            v-model="formData.workedFamousCompanyList"
            multiple
            placeholder="请选择知名公司"
            class="form-select"
          >
            <el-option
              v-for="item in famousCompanyList"
              :key="item.id"
              :label="item.shortName"
              :value="item.shortName"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 个人简介 -->
        <el-form-item label="个人简介" prop="introduction">
          <el-input
            v-model="formData.introduction"
            type="textarea"
            :rows="4"
            placeholder="请输入个人简介"
            maxlength="300"
            show-word-limit
            class="form-textarea"
          ></el-input>
        </el-form-item>
      </el-form>

      <!-- 提示区域 -->
      <div v-if="showTips" class="tips-section">
        <div class="tips-title">温馨提示：</div>
        <div class="tips-content">
          <div v-if="showWorkYearsTip" class="tip-item">
            <i class="el-icon-info"></i>
            <span>工作年限超过5年时，社保记录视频中需要有第一年参加工作的记录。</span>
          </div>
          <div v-if="showCityTip" class="tip-item">
            <i class="el-icon-info"></i>
            <span>所在城市为"北上广深"等一线城市时，社保记录视频中需要有对应城市的工作记录。</span>
          </div>
          <div v-if="showCompanyTip" class="tip-item">
            <i class="el-icon-info"></i>
            <span>有名企经历时，社保记录视频中需要有对应公司的工作记录。</span>
          </div>
          <div v-if="showUploadTip" class="tip-item">
            <i class="el-icon-info"></i>
            <span
              >可在<a href="#" @click.prevent="goToSocialSecurity">社保记录页</a>上传视频文件，可打码，样例可参照<a
                href="#"
                @click.prevent="goToExample"
                >社保样例视频</a
              >。</span
            >
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit" :loading="submitting" class="submit-btn">
        {{ submitButtonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {mapState} from 'vuex'
import {
  getModifyInfoDetail,
  submitModifyInfo,
  submitModifyApplication,
  getEmployeeOccupationList,
  getAreaList,
  getFamousInternetCompanyShortNameList
} from '../../api/consultingService'

export default {
  name: 'ModifyInfoDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    consultantId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      formData: {
        occupationId: null,
        workYears: null,
        areaId: null,
        hasFamousCompany: false,
        workedFamousCompanyList: [],
        introduction: ''
      },
      areaIdArray: [],
      submitting: false,
      loading: false,
      isSubmittingSuccess: false, // 标记是否提交成功
      occupationList: [],
      workYearsOptions: [],
      areaList: [],
      famousCompanyList: [],
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'childrenList',
        checkStrictly: true
      },
      initworkYears: '',
      workedFamous: [],
      dataConfig: {},
      rules: {
        occupationId: [{required: true, message: '请选择职业', trigger: 'change'}],
        workYears: [{required: true, message: '请选择工作年限', trigger: 'change'}],
        areaId: [{required: true, message: '请选择所在城市', trigger: 'change'}],
        introduction: [
          {required: true, message: '请输入个人简介', trigger: 'blur'},
          {min: 50, max: 300, message: '个人简介长度应在50-300字之间', trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    // 弹层标题（带图标）
    dialogTitle() {
      return '修改信息'
    },
    ...mapState(['AreaList', 'EmployeeOccupationList', 'FamousInternetCompanyShortNameList']),
    // 是否显示提示区域
    showTips() {
      return this.showWorkYearsTip || this.showCityTip || this.showCompanyTip
    },

    // 工作年限提示
    showWorkYearsTip() {
      return this.formData.workYears > 5
    },

    // 城市提示
    showCityTip() {
      if (!this.formData.areaId) return false
      // 获取 areaId 的数组形式用于查找城市名称
      const areaIdArray = this.getAreaIdArray(this.formData.areaId)
      if (!areaIdArray) return false
      const cityName = this.getCityName(areaIdArray)
      return ['北京', '上海', '广州', '深圳'].includes(cityName)
    },

    // 名企经历提示
    showCompanyTip() {
      return this.formData.hasFamousCompany && this?.formData.workedFamousCompanyList?.length > 0
    },

    // 上传提示
    showUploadTip() {
      return this.showWorkYearsTip || this.showCityTip || this.showCompanyTip
    },

    // 提交按钮文本
    submitButtonText() {
      return this.needAudit ? '申请修改' : '修改'
    },

    // 是否需要审核
    needAudit() {
      const company = this.formData.workedFamousCompanyList
      const companyStr = JSON.stringify(company)
      const chagneCompanyStr = JSON.stringify(this.workedFamous)
      return (
        (this.showWorkYearsTip && this.formData.workYears != this.initworkYears) ||
        (this.showCityTip && this.getAreaIdValue(this.formData.areaId) != this.areaIdArray) ||
        (this.showCompanyTip && companyStr !== chagneCompanyStr)
      )
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    // 统一处理 areaId：数组取最后一项，字符串直接返回
    getAreaIdValue(areaId) {
      if (!areaId) return null
      if (Array.isArray(areaId)) {
        return areaId.length > 0 ? areaId[areaId.length - 1] : null
      }
      return String(areaId)
    },

    // 获取 areaId 的数组形式（用于组件显示）
    getAreaIdArray(areaId) {
      if (!areaId) return null
      if (Array.isArray(areaId)) return areaId
      // 如果是字符串，需要找到对应的省市区路径
      return this.convertAreaIdToArray(areaId)
    },

    // 将字符串 areaId 转换为数组格式（供组件使用）
    convertAreaIdToArray(areaId) {
      if (!areaId) return null
      if (Array.isArray(areaId)) return areaId

      // 如果是字符串，需要找到对应的省市区路径
      const areaIdStr = String(areaId)
      // 遍历 areaList 找到对应的路径
      for (const province of this.areaList) {
        // 检查是否是省份本身
        if (String(province.id) === areaIdStr) {
          return [province.id]
        }
        // 检查是否是城市
        if (province.childrenList && province.childrenList.length > 0) {
          for (const city of province.childrenList) {
            if (String(city.id) === areaIdStr) {
              return [province.id, city.id]
            }
          }
        }
      }
      // 如果找不到，返回原值（可能是无效的 areaId）
      return areaId
    },

    // 生成工作年限选项
    generateWorkYearsOptions() {
      this.workYearsOptions = []
      for (let i = 1; i <= 30; i++) {
        this.workYearsOptions.push({
          value: i,
          label: `${i}年`
        })
      }
    },

    // 初始化数据
    async initData() {
      this.loading = true
      this.isSubmittingSuccess = false // 重置提交成功标志
      this.generateWorkYearsOptions() // 生成工作年限选项
      try {
        // 获取当前信息
        const res = await getModifyInfoDetail({consultantId: this.consultantId})
        if (res.code === 200) {
          const data = res.data
          // 将 areaId 转换为数组格式（供级联选择器使用）
          const areaIdArray = this.getAreaIdArray(data.areaId)
          this.dataConfig
          this.formData = {
            occupationId: data.occupationId,
            workYears: data.workYears,
            areaId: areaIdArray,
            hasFamousCompany: data.workedFamousCompanyList && data.workedFamousCompanyList.length > 0,
            workedFamousCompanyList: data.workedFamousCompanyList || [],
            introduction: data.introduction || ''
          }
          this.areaIdArray = areaIdArray
          this.workedFamous = data.workedFamousCompanyList || []
          this.dataConfig = this.formData
          this.initworkYears = data.workYears
        }

        // 获取选项数据
        await this.loadOptions()
      } catch (error) {
        console.error('获取修改信息失败:', error)
        this.$message.error('获取信息失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    // 加载选项数据
    async loadOptions() {
      try {
        // 并行获取所有选项数据
        const [occupationRes, areaRes, companyRes] = await Promise.all([
          getEmployeeOccupationList(),
          getAreaList(),
          getFamousInternetCompanyShortNameList()
        ])

        // 设置职业列表
        if (occupationRes.code === 200) {
          this.occupationList = occupationRes.data || []
        } else {
          // 如果API失败，使用Vuex中的数据
          this.occupationList = this.EmployeeOccupationList || []
        }

        // 设置地区列表
        if (areaRes.code === 200) {
          this.areaList = areaRes.data || []
        } else {
          // 如果API失败，使用Vuex中的数据
          this.areaList = this.AreaList || []
        }

        // 设置知名公司列表
        if (companyRes.code === 200) {
          this.famousCompanyList = companyRes.data || []
        } else {
          // 如果API失败，使用Vuex中的数据
          this.famousCompanyList = this.FamousInternetCompanyShortNameList || []
        }
      } catch (error) {
        console.error('获取选项数据失败:', error)
        // 使用Vuex中的备用数据
        this.occupationList = this.EmployeeOccupationList || []
        this.areaList = this.AreaList || []
        this.famousCompanyList = this.FamousInternetCompanyShortNameList || []
      }
    },

    // 处理名企经历变化
    handleFamousCompanyChange(value) {
      if (!value) {
        this.formData.workedFamousCompanyList = []
      }
    },

    // 获取城市名称
    getCityName(areaId) {
      if (!areaId) return ''
      // 确保 areaId 是数组格式
      const areaIdArray = Array.isArray(areaId) ? areaId : this.convertAreaIdToArray(areaId)
      if (!areaIdArray || areaIdArray.length === 0) return ''

      // 统一转换为字符串进行比较
      const provinceId = String(areaIdArray[0])
      const province = this.areaList.find(p => String(p.id) === provinceId)

      if (!province) return ''

      // 如果没有子级（即本身就是城市），直接返回省份名称
      if (!province.childrenList || province.childrenList.length === 0) {
        return province.name
      }

      // 查找城市
      if (areaIdArray.length < 2) return ''
      const cityId = String(areaIdArray[1])
      const city = province.childrenList.find(c => String(c.id) === cityId)

      return city ? city.name : ''
    },

    // 生成确认文案
    generateConfirmMessage() {
      const conditions = []
      const company = this.formData.workedFamousCompanyList
      const companyStr = JSON.stringify(company)
      const chagneCompanyStr = JSON.stringify(this.workedFamous)
      const isChangeYear = this.showWorkYearsTip && this.formData.workYears != this.initworkYears
      const isChangeCity = this.showCityTip && this.getAreaIdValue(this.formData.areaId) != this.areaIdArray
      const isChangeCompany = this.showCompanyTip && companyStr !== chagneCompanyStr

      if (isChangeYear) {
        conditions.push('工作年限超过5年')
      }
      if (isChangeCity) {
        conditions.push('所在城市为一线城市')
      }
      if (isChangeCompany) {
        conditions.push('有名企经历')
      }

      if (conditions.length === 0) {
        return '确认要修改吗？'
      }

      return `您${conditions.join('，')}，需要由后台客服核实您的社保记录视频无误后才可生效。确定要申请修改吗？`
    },

    // 提交表单
    async handleSubmit() {
      try {
        // 表单验证
        // if (this.needAudit) {
        await this.$refs.modifyForm.validate()

        // 确认对话框
        let confirmMessage = this.generateConfirmMessage()
        if (!this.needAudit) {
          confirmMessage = '确认修改吗'
        }
        await this.$confirm(confirmMessage, '确认修改', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        // }

        this.submitting = true

        // 提交数据
        const submitData = {
          consultantId: this.consultantId,
          occupationId: this.formData.occupationId,
          workYears: this.formData.workYears,
          areaId: this.getAreaIdValue(this.formData.areaId),
          workedFamousCompanyList: this.formData.hasFamousCompany ? this.formData.workedFamousCompanyList : [],
          introduction: this.formData.introduction
        }

        // 根据是否需要审核选择不同的接口
        const res = this.needAudit ? await submitModifyApplication(submitData) : await submitModifyInfo(submitData)

        if (res.code === 200) {
          if (this.needAudit) {
            this.$message.success('已提交修改申请')
          } else {
            this.$message.success('修改成功')
          }
          this.$emit('submitSuccess', res.data)
          this.handleClose(true) // 强制关闭，不显示确认提示
        } else {
          this.$message.error(res.msg || '提交失败')
        }
      } catch (error) {
        // this.$message.error(error.message || '')
      } finally {
        this.isSubmittingSuccess = true // 标记提交成功
        this.submitting = false
      }
    },

    // 跳转到社保记录页
    goToSocialSecurity() {
      const id = this.consultantId
      if (!id) {
        this.$message.error('缺少顾问ID，无法跳转')
        return
      }

      // 直接跳转到社保记录页，传递 consultant_id 参数
      // 页面内部会调用后端接口获取播放参数并进行身份校验
      this.$router.push({
        path: '/socialSecurity',
        query: {consultant_id: String(id)}
      })
    },

    // 跳转到样例视频
    async goToExample() {
      try {
        // 从后端获取示例视频配置
        const {getDefaultSocialSecurity} = await import('@/api/socialSecurity')
        const response = await getDefaultSocialSecurity()
        if (response.code === 200 && response.data) {
          const {appId, psign, socialSecurityCloudFileId, fileName} = response.data
          // 跳转到视频播放页，传递四个参数
          this.$router.push({
            path: '/videoPlay',
            query: {
              appId,
              psign,
              cloud_video_id: socialSecurityCloudFileId,
              video_name: fileName || '社保记录示例'
            }
          })
        } else {
          this.$message.error('获取示例视频配置失败')
        }
      } catch (error) {
        console.error('获取示例视频配置失败:', error)
        this.$message.error('获取示例视频配置失败，请重试')
      }
    },

    // 处理弹窗关闭事件
    handleDialogClose() {
      this.loading = false
      this.$emit('update:visible', false)
    },

    // 关闭弹窗
    async handleClose(forceClose = false) {
      // 如果是强制关闭（如提交成功后）或已经提交成功，直接关闭
      if (forceClose === true || this.isSubmittingSuccess) {
        this.loading = false
        this.$emit('update:visible', false)
        return
      }

      // 如果传递的是函数（Element UI的before-close回调），执行确认逻辑
      if (typeof forceClose === 'function') {
        try {
          await this.$confirm('确定要关闭吗？未保存的修改将丢失。', '确认关闭', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          // 用户确认关闭，调用Element UI的关闭函数
          forceClose()
        } catch (error) {
          // 用户取消关闭，不做任何操作
        }
        return
      }

      // 普通关闭逻辑
      try {
        await this.$confirm('确定要关闭吗？未保存的修改将丢失。', '确认关闭', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        this.loading = false
        this.$emit('update:visible', false)
      } catch (error) {
        // 用户取消关闭，不做任何操作
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .custom-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    padding: 24px 40px 20px;
    border-bottom: none;

    .el-dialog__title {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      display: flex;
      align-items: center;
      gap: 8px;

      &::before {
        content: '';
        display: inline-block;
        width: 24px;
        height: 24px;
        background-image: url('/img/bianji.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
    }

    .el-dialog__headerbtn {
      top: 24px;
      right: 40px;
    }
  }

  .el-dialog__body {
    padding: 24px 60px;
  }

  .el-dialog__footer {
    padding: 20px 40px 32px;
    border-top: none;
  }
}

.modify-info-dialog {
  .modify-content {
    .el-form {
      .el-form-item {
        margin-bottom: 24px;

        .el-form-item__label {
          font-size: 16px;
          color: #333;
          font-weight: 500;
          padding-bottom: 8px;
          text-align: left;
        }

        .el-form-item__content {
          .form-select,
          .form-textarea {
            width: 100%;
          }
        }
      }
    }

    .tips-section {
      margin-top: 24px;
      padding: 20px;
      background-color: #f8f9fa;
      border-radius: 8px;
      border-left: 4px solid #409eff;

      .tips-title {
        font-weight: 500;
        font-size: 16px;
        color: #333;
        margin-bottom: 16px;
      }

      .tips-content {
        .tip-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 12px;
          font-size: 14px;
          color: #666;
          line-height: 1.6;

          &:last-child {
            margin-bottom: 0;
          }

          i {
            color: #409eff;
            margin-right: 8px;
            margin-top: 2px;
            flex-shrink: 0;
          }

          a {
            color: #409eff;
            text-decoration: none;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }

  .dialog-footer {
    text-align: center;
    padding: 0;

    .submit-btn {
      width: 60%;
      height: 48px;
      font-size: 18px;
      font-weight: 500;
      border-radius: 8px;
      background: #5ad3cd;
      border-color: #5ad3cd;

      &:hover {
        background: #4ab8b2;
        border-color: #4ab8b2;
      }
    }
  }
}
</style>
